module.exports = __webpack_public_path__ + "media/images/img-youchi-e61f1de7e47964e1ff703efc7ced7f1e.png";